import React from "react";

const Hero = () => {
  return (
    <section className="hero">
      <img
        src="/hero3.jpg"
        alt="Professional residential window cleaning in Utah County"
        className="hero-img"
      />

      <div className="hero-overlay">
        <div className="hero-content">
          <div className="hero-review">


          <div className="hero-rating">
            <img
              src="/google-reviews.png"
              alt="Google Reviews"
              className="hero-google-logo"
            />

            <span className="hero-rating-text">
              <strong>100+ Verified Google Reviews</strong>
            </span>
          </div>
          </div>

          <h1>
            Dirty Windows?
            <span>
              We Make Them{" "}
              <span className="disappear-word">Disappear.</span>
            </span>
          </h1>

          <p>
            Professional window cleaning in Utah that restores clear
            views, brighter rooms, and a home you’re proud of.
          </p>

          <div className="hero-buttons">
            <button
              type="button"
              className="header-quote-button about-hero-call-button"
              onClick={() => (window.location.href = "tel:8016618232")}
            >
              <svg
                className="button-phone-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.9.35 1.78.68 2.62a2 2 0 0 1-.45 2.11L8.1 9.9a16 16 0 0 0 6 6l1.45-1.19a2 2 0 0 1 2.11-.45c.84.33 1.72.56 2.62.68A2 2 0 0 1 22 16.92z" />
              </svg>

              <span>CALL US</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;